var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3135 0.29325C6.9225 -0.09775 6.2895 -0.09775 5.8995 0.29325L2.5355 3.65725L1.7065 2.82925C1.3165 2.43825 0.6835 2.43825 0.2925 2.82925C-0.0975 3.21925 -0.0975 3.85225 0.2925 4.24325L1.8285 5.77825C2.2185 6.16925 2.8515 6.16925 3.2425 5.77825L7.3135 1.70725C7.7045 1.31725 7.7045 0.68425 7.3135 0.29325Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxArrow);
export default __webpack_public_path__ + "static/media/checkboxArrow.17feba5d.svg";
export { ForwardRef as ReactComponent };